module.exports = __webpack_public_path__ + "img/Back.77542061.svg";